import React from "react";
const TH = () => {
  return (
    <>
      <>
  <div id="main-area">
  <div id="article">
  <h1 id="Rules">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Rules" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    Rules
  </h1>
  <p>
  This page explains Constitutional Principles and Rules & Sanctions of EnbyBase server.
  <br />For view Thai language version, please click above icon.
  </p>
  <h2 id="Constitutional Principles">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Constitutional Principles" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    Constitutional Principles
  </h2>

<h3 id="cpsection1" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 1.
  </h3>
  <p>
  This server is a safe place to Non-binary people, transgender people, and the entire LGBTQIAN+ people.
  <br />From now on, this principles, Rules & Sanctions will use this word: LGBTQIAN+
  </p>
  <h3 id="cpsection2" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 2.
  </h3>
  <p>
  In the case of important discussions, all the process must be proceeded democratically.
  </p>
  <h3 id="cpsection3" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 3.
  </h3>
  <p>
  Other general rules follow 'Rules & Sanctions'.
  </p>
  <h3 id="cpsection4" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 4.
  </h3>
  <p>
  Constitutional Principles, Rules & Sanctions modifications and important issues are carried out according to the entire procedure of In-server voting / parliament on #open-parliament.
  </p>
  <h3 id="cpsection5" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 5.
  </h3>
  <p>
  The official website, YouTube, and external site accounts are modified, added, and deleted according to the owner's permission.
  </p>
  <h3 id="cpsection6" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 6.
  </h3>
  <p>
  This Discord server is not monetised.
  </p>

  <h2 id="Rules & Sanctions">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Rules & Sanctions" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    Rules & Sanctions
  </h2>
  <p>Punishment can be imposed by the moderator, and the defendant can protest by opening a ticket at #contact-mods.
    <br />If you appeal, a public trial will be held in #open-supreme-court.
  </p>
  <h3 id="Section 1 to 10: General">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Rules & Sanctions" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    Section 1 to 10: General
  </h3>
  <h3 id="rssection1" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 1.
  </h3>
  <p>
  Be kind, and respectful to one another.
  <br />Whoever doesn't respect others, shall be punished with account timeout (suspension) of 1 minute to 1 day.
  </p>
  <h3 id="rssection2" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 2.
  </h3>
  <p>
  Keep your Discord profile appropriate.
  <br />Whoever sends spam, shall be punished with account timeout (suspension) of 1 minute to 1 day.
  </p>
  <h3 id="rssection3" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 3.
  </h3>
  <p>
  Do not spam.
  <br />Whoever sends spam, shall be punished with account timeout (suspension) of 1 minute to 1 day.
  </p>
  <h3 id="rssection4" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 4.
  </h3>
  <p>
  No self-promotion or advertisements on this server except self-promotion channel.
  <br />Whoever does self-promotion or advertises on this server except self-promotion channel, shall be punished with account timeout (suspension) of 1 minute to 1 day.
  </p>
  <h3 id="rssection5" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 5.
  </h3>
  <p>
  No transphobic, queerphobic and enbyphobic message. These are strictly prohibited.
  <br />Whoever sends message including transphobic, queerphobic and enbyphobic content shall be punished with account timeout (suspension) of 1 day to 1 week.
  </p>
  <h3 id="rssection6" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 6.
  </h3>
  <p>
  No hate speech or harmful language.
  <br />Whoever does hate speech or uses harmful language, shall be punished with account timeout (suspension) of 1 minute to 1 day.
  </p>
  <h3 id="rssection7" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 7.
  </h3>
  <p>
  No suspicious content.
  <br />Whoever uploads or chats suspicious content, shall be punished with account timeout (suspension) of 1 minute to 1 day.
  </p>
  <h3 id="rssection8" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 8.
  </h3>
  <p>
  Rules are subject to common sense.
  <br />Whoever commits an uncommon behaviour, shall be punished with account timeout (suspension) of 1 minute to 1 day.
  </p>
  <h3 id="rssection9" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 9.
  </h3>
  <p>
  Extremist Ideologies are not allowed on this server and partnership servers.
  <br />Whoever their profile contains the extremist ideology, they will be notified by DM (Direct Message) and shall be punished with account timeout (suspension) of 1 day.
  <br />Any partnership is terminated if this partnership server spreads extremist ideology or is present on the server.
  </p>
  <h3 id="rspc" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
  Section 10. Aggravated Punishment
  </h3>
  <p>
  Account timeout (suspension) of 1 week for the 2nd time, including all warnings (Section 1 to 9) received so far.
  <br />Account kicked (banishment) for the 3rd time, including all warnings (Section 1 to 9) received so far.
  <br />Violation more than 4th times may result in an immediate and permanent ban.
<br/>*Punishments on Section 10 may overlap with the provisions of other sections.
</p>
<h3 id="Section 11 to 12: Server and Owner">
    {" "}
    <a href="https://discord.com/channels/1175757068779663410/1175764882088534136" aria-labelledby="Rules & Sanctions" className="anchor-heading">
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <use xlinkHref="#svg-link" />
      </svg>
    </a>{" "}
    Section 11 to 12: Server and Owner
  </h3>
  <h3 id="rssection11" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 11.
  </h3>
  <p>
  Whoever attempts to hack the server shall be punished with permanent ban, report to Discord, and take legal action.
  </p>
  <h3 id="rssection12" style={{fontFamily: 'FoundryContextW03Md, sans-serif'}}>
    Section 12.
  </h3>
  <p>
  Whoever defames, use swear word to the owner shall be punished with account timeout (suspension) of 1 day to 1 week and/or kick or permanent ban.
  </p>
</div>
</div>
</>

    </>
  );
}

export default TH;